const initState = {
    posts: 'hello'
};

const rootReducer = (state = initState, action) => {
    return state
};

export default rootReducer;